
export default {
    props: {
        href: {
            type: String,
            default: null
        }
    }
};
